<template>
  <v-dialog v-model="dialog" max-width="850">
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        v-if="temSolicitacaoPendente()"
        v-on="on"
        v-bind="attrs"
        color="warning"
        small
        rounded
        outlined
        class="mt-3"
        >Corrigir Documentação</v-btn
      >
      <v-btn color="success" rounded v-on="on" v-bind="attrs" block v-else
        >Atualizar Endereço</v-btn
      >
    </template>
    <v-card>
      <v-card-title class="green lighten-4 primary--text font-weight-bold">{{
        labelButton()
      }}</v-card-title>
      <v-card-subtitle class="green lighten-4"
        >Anexar documentos</v-card-subtitle
      >
      <v-card-text class="pt-5">
        <v-card color="grey lighten-3" flat class="mb-3">
          <v-card-text>
            <anexar-documentos
              :items="configAnexos.find((c) => c.codcategoria == 4).anexos"
            />
          </v-card-text>
        </v-card>
        <v-btn
          rounded
          block
          color="success"
          @click="confirmarSolicitacao()"
          :loading="confirmando"
          >Confirmar Solicitação</v-btn
        >
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn @click="dialog = false" rounded text>Fechar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { getBase64 } from "@/global";
import axios from "axios";
import { mapGetters, mapMutations, mapState } from "vuex";
import AnexarDocumentos from "../../../components/anexar-documentos/AnexarDocumentos.vue";
export default {
  components: {
    AnexarDocumentos,
  },
  watch: {
    dialog: function (open) {
      if (open) {
        this.setDocs([]);
      }
    },
  },
  computed: {
    ...mapState("atualizacaoCadastral", ["configAnexos", "solicitacoes"]),
    ...mapState("anexos", ["docs"]),
  },
  data: () => ({
    dialog: false,
    confirmando: false,
  }),
  methods: {
    ...mapMutations("anexos", ["setDocs"]),
    ...mapGetters("atualizacaoCadastral", ["temSolicitacaoPendente"]),
    getColorButton() {
      return this.temSolicitacaoPendente() ? "warning" : "success";
    },
    labelButton() {
      return this.temSolicitacaoPendente()
        ? "Corrigir Documentação"
        : "Atualizar Endereço";
    },
    async confirmarSolicitacao() {
      this.confirmando = true;

      var anexosEnviar = new Array();
      for (const doc of this.docs) {
        var arq = await getBase64(doc.file[0]);
        anexosEnviar.push({
          id: doc.codigo,
          arquivo: arq.split(",")[1],
        });
      }

      var cod = 0;
      if (this.temSolicitacaoPendente()) {
        cod = this.solicitacoes.find((s) => s.status == 2).codigo;
      }

      await axios
        .post(
          "/colaborador/atualizacao-cadastral",
          JSON.stringify({
            codigo: cod,
            ambiente: "WEB",
            anexos: anexosEnviar,
          }),
          {
            params: {
              funcao: "ALTERAR-ENDERECO",
            },
          }
        )
        .then((res) => {
          if (res.data.success) {
            this.$toasted.success(res.data.msg);
            this.dialog = false;
            this.$router.go();
          } else this.$toasted.error(res.data.msg);
        })
        .catch((e) => this.$toasted.error(e))
        .finally(() => {
          this.confirmando = false;
        });
    },
  },
};
</script>

<style>
</style>
